import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from "../../components/Icon/Icon";
import OutOfStockIcon from "../../icons/out-of-stock.svg";
import { useTranslations } from "../../providers/useTranslations";
import styles from "./OutOfStock.module.scss";
export const OutOfStock = ({ hideIcon = false, className }) => {
    const { __ } = useTranslations();
    return (_jsxs("div", { className: className, "data-testid": "outOfStockContainer", children: [_jsx("span", { className: styles.circle }), !hideIcon && (_jsx("span", { className: styles.icon, children: _jsx(Icon, { dataTestId: "outOfStock-icon", component: OutOfStockIcon, fill: "#373A36", width: "32px", height: "32px" }) })), _jsx("span", { className: styles.outOfStock, children: __("libs.ui.out_of_stock.title") })] }));
};
//# sourceMappingURL=OutOfStock.js.map